module.exports = __webpack_public_path__ + "static/media/25-1.6694cfa4.mp3";